<script>
  import { Link } from "svelte-routing";
  import * as testContents from "../configs/testItems.json";

  var testItemsArray = [];
  function put(item) {
    testItemsArray.push(item);
    return testItemsArray.length;
  }

  import * as calculateCorrelation from "calculate-correlation";

  let currentCorrelation = undefined;

  function filterDatasetHasSpecificQuestions(d, q) {
    return d.filter((take) =>
      q.every((qe) => take.map(({ key: k, value: v }) => k).includes(qe))
    );
  }

  function correlations() {
    const validSamples = filterDatasetHasSpecificQuestions(
      filteredDataset,
      selectedRows.map((rowItem) => rowItem.ident)
    );
    if (validSamples.length <= 0) {
      return;
    }
    currentCorrelation =
      selectedRows.length === 2
        ? calculateCorrelation.default(
            ...selectedRows.map((rowItem) =>
              validSamples.map(
                (record) =>
                  record.filter(
                    ({ key: k, value: v }) => k === rowItem.ident
                  )?.[0]?.value ?? 1 / 2
              )
            )
          )
        : undefined;
  }

  let selectedRows = [];
  const SELECTION_CLASSES = ["bg-info", "bg-gradient"];
  function select(item, currentTarget) {
    const MAX_SELECTS = 2;
    if (selectedRows.length >= MAX_SELECTS) return;
    selectedRows.push(item);
    currentTarget.classList.add(...SELECTION_CLASSES);
    correlations();
  }
  function unselect(item, currentTarget) {
    selectedRows = selectedRows.filter((selected) => selected !== item);
    currentTarget.classList.remove(...SELECTION_CLASSES);
    correlations();
  }

  var userInputValidity = false;

  var boolExpression = "";

  var dataset, filteredDataset;

  let hasData = false,
    isDataLoaded = false;

  function refresh() {
    filteredDataset = dataset.filter((record) => {
      let returnVal = true;
      try {
        returnVal = eval(
          "(" +
            boolExpression
              .replaceAll("not", "!")
              .replaceAll("or", "||")
              .replaceAll("and", "&&")
              .replace(/#\d+/gim, (match) => {
                return (
                  record.filter(
                    ({ key: k, value: v }) =>
                      k === testItemsArray[Number(match.substring(1))].ident
                  )?.[0]?.value ?? false
                );
              }) +
            ")"
        );
        userInputValidity = true;
      } catch (err) {
        console.error(err);
        returnVal = true;
        userInputValidity = false;
      } finally {
        return returnVal;
      }
    });
    //console.log(testItemsArray);
    for (let testedItem of testItemsArray) {
      const n = filterDatasetHasSpecificQuestions(filteredDataset, [
        testedItem.ident,
      ]).length; // number of testers who took the test when the question existed
      //      console.log(testedItem);
      testedItem.currentStat =
        n > 0
          ? filteredDataset.reduce(
              (prev, cur) =>
                prev +
                (cur.filter(
                  ({ key: k, value: v }) => k === testedItem.ident
                )?.[0]?.value ?? 0),
              0
            ) / n
          : -1;
      testedItem = testedItem;
    }
    testItemsArray = testItemsArray;

    correlations();
  }

  import { decompressServe } from "../global";
  import { onMount } from "svelte";
  fetch("/api/database-read?realm=test-items")
    .then(function (response) {
      if (response.ok) {
        return response.text();
      }
      throw new Error("Something went wrong");
    })
    .then(function (compressed) {
      const json = decompressServe(compressed);
      dataset = json;
    })
    .catch((error) => {
      console.error("defaulting to empty dataset");
      dataset = [];
    })
    .finally(() => {
      refresh();
      hasData = dataset.length > 0;
      isDataLoaded = true;
    });

  import { adsConfig } from "../stores/Store";
  onMount(() => {
    adsConfig.set({
      footerBanner: false,
      interstitial: false,
    });
  });
</script>

<svelte:head>
  <title>Statistics · 27types</title>
</svelte:head>

<header>
  <section>
    <h1><em>27types</em>’s Statistics</h1>
    <div role="doc-subtitle" class="lead">
      Analyze Data Anonymously Collected From Test-Takers
    </div>
  </section>
  <section>
    <Link to="/">
      <button class="btn btn-primary shadow-sm">Take the Test</button>
    </Link>
    <Link to="/catalog">
      <button class="btn btn-warning shadow-sm">View The 27 Types</button>
    </Link>
  </section>
  <p>
    The table displays the percentage of testers who checked the box of each
    test item.
  </p>
  <p>You can select 2 rows to get 2 questions’ correlation coefficients.</p>
  <p>
    You can enter boolean expressions to see stats only from testers who
    answered specfic questions in certain ways.
  </p>
</header>

<main class="rel">
  <table class="table table-bordered table-hover bg-white shadow">
    <thead class="sticky-top bg-white shadow-sm">
      <tr>
        <th scope="col">#</th>
        <th scope="col">Question</th>
        <th scope="col">% Testers Answered <em>Yes</em></th>
      </tr>
    </thead>
    <tbody>
      {#each testContents.default as section}
        {#each section.items as item}
          {@const itemGlobalIndex = put(item)}
          {@const cent =
            100 * (testItemsArray[itemGlobalIndex - 1]?.currentStat ?? 0)}
          <tr
            on:click={(e) =>
              selectedRows.includes(item)
                ? unselect(item, e.currentTarget)
                : select(item, e.currentTarget)}
          >
            <th scope="row">{itemGlobalIndex}</th>
            <td>{item.main}</td>
            {#if cent === -100}
              <td style="background:silver;">
                <em>No Data</em>
              </td>
            {:else}
              <td style="--width:{cent}%;">
                <span class="negative"
                  >{Math.round(cent * 10 ** 3) / 10 ** 3}%</span
                >
                <span class="portion"></span>
              </td>
            {/if}
          </tr>
        {/each}
      {/each}
    </tbody>
  </table>
  <section class="card shadow-lg sticky-bottom">
    <div class="card-header pb-0">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="home-tab"
            data-bs-toggle="tab"
            data-bs-target="#home"
            type="button"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >
            Correlations
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#profile"
            type="button"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >
            Conditionals
          </button>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <p>
            Click or tap on 2 rows in the above table to see the correlation
            coefficient of 2 test questions.
          </p>
          <div class="lead">
            Correlation Coefficient <strong
              >: <strong>{("" + currentCorrelation).replace("-", "−")}</strong
              ></strong
            >
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="profile"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          <p>
            Type a boolean expression in the text box below to make the above
            percentages be calculated exculsively with testers within your
            specified cohort. For example, the boolean expression <code
              >#18 and (not #13)</code
            > makes the table display the statistics of the test-takers who had vaginal
            sex and didn’t have oral sex.
          </p>
          <textarea
            class="form-control"
            rows="2"
            placeholder="Example : #18 and (not #13)"
            bind:value={boolExpression}
            on:input={() => {
              try {
                refresh();
              } catch {}
            }}
            disabled={!hasData}
          ></textarea>
          <small
            style="color:var(--bs-{boolExpression.length
              ? userInputValidity
                ? 'success'
                : 'danger'
              : 'gray'})"
            >{boolExpression.length
              ? "Expression is " + (userInputValidity ? "" : "in") + "valid"
              : "Status : Blank Input"}</small
          >
        </div>
      </div>
    </div>
  </section>

  {#if !isDataLoaded}
    <div class="loading-blurb-container">
      <div class="loading-blurb">Loading Dataset…</div>
    </div>
  {/if}
</main>

<style>
  .rel {
    position: relative;
  }
  .loading-blurb-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    z-index: 100;

    background: repeating-linear-gradient(
      45deg,
      #8882 0,
      #8882 1rem,
      #8885 1rem,
      #8885 2rem
    );
  }
  .loading-blurb {
    background: lightgray;
    border-radius: 1.5rem;
    padding: 1.5rem 2rem;
    position: sticky;
    color: #666;
    font-weight: 500;
    bottom: 2.5rem;
    top: 1.25rem;
    font-size: 1.25rem;
    border: 1px solid white;
    box-shadow:
      0 0 0 1px #0008,
      0 0 2.5rem -1.25rem black;
    z-index: 1000;
    text-shadow: 0 0 1px white;
  }

  .table {
    z-index: 1;
    position: relative;
  }
  .sticky-top,
  .sticky-bottom {
    background-clip: padding-box;
  }
  .sticky-bottom {
    position: sticky;
    bottom: -1px;
    z-index: 4;
    border-top-color: #0000007f;
  }
  .sticky-top {
    top: -1px;
    z-index: 3;
    /*      border-bottom-width: 1px;*/
    border-bottom-color: #0000007f;
  }
  code {
    display: inline-block;
  }
  .card-header.pb-0 {
    padding-top: 0.25rem !important;
    padding-left: 0.25rem !important;
    border-bottom: 0;
  }

  td {
    position: relative;
  }
  td > span.negative {
    color: black;
  }
  td > span.portion,
  td > span.negative::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
  }
  td > span.portion {
    background-color: white;
    z-index: 1;
    mix-blend-mode: exclusion;
    width: var(--width);
  }
  td > span.negative::after {
    z-index: 2;
    right: 0;
    background-color: var(--bs-blue);
    content: "";
    width: var(--width);
    mix-blend-mode: lighten;
  }
</style>
